import MuiButton, { ButtonProps } from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import AutoAwesomeMosaicIcon from '@mui/icons-material/AutoAwesomeMosaic';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CircularProgress from '../CircularProgress';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PrintIcon from '@mui/icons-material/Print';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import SendIcon from '@mui/icons-material/Send';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';
import WorkOffIcon from '@mui/icons-material/WorkOff';
import { IBaseComponentProps } from 'src/core/base.component.props';
import { isVisible } from 'src/utils/formAuthHelper';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import { buttonType } from '../../core/types';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { SxProps, Theme, styled } from '@mui/material';
import { DoDisturb, MenuOpen, MoveDown, Numbers, Schedule } from '@mui/icons-material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VideocamIcon from '@mui/icons-material/Videocam';
import ModulEnum from "src/enums/ModulEnum";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import DownloadIcon from '@mui/icons-material/Download';
import PanoramaIcon from '@mui/icons-material/Panorama';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import { translate } from 'src/i18n/tHelper';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';


export interface IButtonProps extends ButtonProps, IBaseComponentProps {
  customType?: buttonType;
  loading?: boolean;
  authCode?: string;
  modul?: ModulEnum;
}

const ButtonStyle = styled(MuiButton)(({ theme }) => ({
  // '&.MuiButton-root .MuiButton-startIcon': {
  //   marginRight: '2px',
  //   marginLeft: '-4px'
  // }
}));
const translatePath = "components|iconbtn";
const Button = (props: IButtonProps): JSX.Element => {
  const { customType, loading, authCode, modul, ...rest } = props;

  let text = '';
  const iconSx: SxProps<Theme> = {
    width: { xl: '24px', lg: '16px', md: '16px', xs: '16px', sm: '16px' },
    height: { xl: '24px', lg: '16px', md: '16px', xs: '16px', sm: '16px' },
    paddingRight: '0px'
  };

  // rest.variant = "contained";
  switch (customType) {
    case 'add':
      rest.startIcon = <AddIcon sx={iconSx} />;
      rest.variant = 'contained';
      text = text
        ? props.children.toString()
        : translate(translatePath, 'Ekle');
      break;
    case 'search':
      rest.startIcon = <SearchIcon sx={iconSx} />;
      rest.variant = !rest.variant ? 'outlined' : "contained";
      text = translate(translatePath, 'Ara');
      break;
    case 'cancel':
      rest.color = 'secondary';
      rest.variant = 'outlined';
      rest.color = 'error';
      rest.startIcon = (
        <ClearIcon color={rest.disabled ? 'disabled' : 'error'} sx={iconSx} />
      );
      text = translate(translatePath, 'Vazgeç');
      break;
    case 'close':
      rest.color = 'secondary';
      rest.variant = 'outlined';
      rest.color = 'error';
      rest.startIcon = (
        <CloseIcon color={rest.disabled ? 'disabled' : 'error'} sx={iconSx} />
      );
      text = translate(translatePath, 'Kapat');
      break;
    case 'edit':
      rest.startIcon = <EditIcon sx={iconSx} />;
      rest.variant = 'contained';
      text = translate(translatePath, 'Duzenle');
      break;
    case 'delete':
      rest.startIcon = <DeleteIcon sx={iconSx} />;
      rest.color = 'error';
      rest.variant = 'contained';
      text = translate(translatePath, 'Sil');
      break;
    case 'save':
      rest.startIcon = <SaveIcon sx={iconSx} />;
      rest.variant = 'contained';
      text = translate(translatePath, 'Kaydet');
      break;
    case 'detail':
      rest.color = 'primary';
      rest.startIcon = <AutoAwesomeMosaicIcon sx={iconSx} />;
      rest.variant = 'outlined';
      text = translate(translatePath, 'Detaylar');
      break;
    case 'back':
      rest.color = 'primary';
      rest.startIcon = <ArrowBackIcon sx={iconSx} />;
      rest.variant = 'contained';
      text = translate(translatePath, 'Geri');
      break;
    case 'mailSend':
      rest.startIcon = <ForwardToInboxIcon sx={iconSx} />;
      text = translate(translatePath, 'E - Posta Gönder');
      break;
    case 'mail':
      rest.startIcon = <MailOutlineIcon sx={iconSx} />;
      text = translate(translatePath, 'E - Posta');
      break;
    case 'print':
      rest.startIcon = <PrintIcon sx={iconSx} />;
      text = translate(translatePath, 'Yazdır');
      break;
    case 'return':
      rest.color = 'warning';
      rest.startIcon = <KeyboardReturnIcon sx={iconSx} />;
      rest.variant = 'outlined';
      break;
    case 'send':
      rest.color = 'success';
      rest.startIcon = <SendIcon sx={iconSx} />;
      text = translate(translatePath, 'Gönder');
      break;
    case 'cancelsend':
      rest.color = 'error';
      rest.startIcon = <CancelScheduleSendIcon sx={iconSx} />;
      break;
    case 'tilloff':
      rest.color = 'primary';
      rest.startIcon = <WorkOffIcon sx={iconSx} />;
      // rest.variant = '';
      break;
    case 'check':
      rest.color = 'primary';
      rest.startIcon = <FactCheckIcon sx={iconSx} />;
      text = translate(translatePath, 'Seç');
      break;
    case 'accept':
      rest.color = 'success';
      rest.startIcon = <CheckIcon sx={iconSx} />;
      text = translate(translatePath, 'Onayla');
      break;
    case 'appointment':
      rest.color = 'primary';
      rest.startIcon = <Schedule sx={iconSx} />;
      rest.variant = 'outlined';
      text = translate(translatePath, 'Randevu');
      break;
    case 'clear':
      rest.color = 'error';
      rest.startIcon = <ClearIcon sx={iconSx} />;
      text = translate(translatePath, 'Temizle');
      break;
    case 'visibility':
      rest.startIcon = <VisibilityIcon sx={iconSx} />;
      text = translate(translatePath, 'Önizle');
      break;
    case 'prepare':
      rest.color = 'primary';
      rest.startIcon = <Numbers sx={iconSx} />;
      text = translate(translatePath, 'Hazirla');
      break;
    case 'video':
      rest.color = 'primary';
      rest.startIcon = <VideocamIcon sx={iconSx} />;
      text = text
        ? props.children.toString()
        : text = translate(translatePath, 'Video');
      break;
    case 'play':
      rest.variant = 'outlined';
      rest.color = 'primary';
      rest.startIcon = <PlayCircleOutlineIcon sx={iconSx} />;
      text = text
        ? props.children.toString()
        : text = translate(translatePath, 'Video');
      break;
    case 'stop':
      rest.variant = 'outlined';
      rest.color = 'error';
      rest.startIcon = <NotInterestedIcon sx={iconSx} />;
      text = text
        ? props.children.toString()
        : text = translate(translatePath, 'Video');
      break;
    case 'view':
      rest.color = 'primary';
      rest.startIcon = <PanoramaIcon sx={iconSx} />;
      text = text
        ? props.children.toString()
        : text = translate(translatePath, 'Görüntüle');
      break;
    case 'download':
      rest.color = 'primary';
      rest.startIcon = <DownloadIcon sx={iconSx} />;
      text = text
        ? props.children.toString()
        : text = translate(translatePath, 'İndir');
      break;
    case 'upload':
      rest.color = 'primary';
      rest.variant = 'contained';
      rest.startIcon = <DriveFolderUploadIcon sx={{
        ...iconSx,
        cursor: 'pointer',
      }} />;
      text = text ? props.children.toString() : translate(translatePath, 'Yükle');
      break;
    case 'Menu':
      rest.color = 'info';
      rest.variant = 'contained';
      rest.startIcon = <MenuOpen sx={{
        ...iconSx,
        cursor: 'pointer',
      }} />;
      text = text ? props.children.toString() : translate(translatePath, 'Menü');
      break;

    case 'waiting':
      rest.color = 'warning';
      rest.variant = 'contained';
      rest.startIcon = <AccessTimeIcon sx={{
        ...iconSx,
        cursor: 'pointer',
      }} />;
      text = text ? props.children.toString() : translate(translatePath, 'Bekleyen Talepler');
      break;
    case 'cargo':
      rest.color = 'success';
      rest.variant = 'contained';
      rest.startIcon = <DeliveryDiningIcon sx={{
        ...iconSx,
        cursor: 'pointer',
      }} />;
      text = text ? props.children.toString() : translate(translatePath, 'Kurye/Kargo Kabul');
      break;
    case 'transfer':
      rest.color = 'warning';
      rest.variant = 'contained';
      rest.startIcon = <MoveDown sx={{
        ...iconSx,
        cursor: 'pointer',
      }} />;
      text = text ? props.children.toString() : translate(translatePath, 'Şablon Aktar');
      break;
    case 'change':
      rest.color = 'info';
      rest.variant = 'contained';
      rest.startIcon = <ChangeCircleIcon sx={{
        ...iconSx,
        cursor: 'pointer',
      }} />;
      text = text ? props.children.toString() : translate(translatePath, 'Değiştir');
      break;
    case 'deny':
      rest.color = 'error';
      rest.variant = 'contained';
      rest.startIcon = <DoDisturb sx={{
        ...iconSx,
        cursor: 'pointer',
      }} />;
      text = text ? props.children.toString() : translate(translatePath, 'Reddet');
      break;
    case 'attachmoney':
      rest.color = 'success';
      rest.variant = 'contained';
      rest.startIcon = <CardGiftcardIcon sx={{
        ...iconSx,
        cursor: 'pointer',
      }} />;
      text = text ? props.children.toString() : translate(translatePath, 'Ücretsize Çevir');
      break;
  }
  return (
    isVisible(authCode, modul) && (
      <MuiButton
        {...rest}
        // sx={{

        //     '&.MuiButton-root .MuiButton-startIcon': {
        //     marginRight: '2px',
        //     marginLeft: '-4px'
        //   }
        // }}
        fullWidth
        variant={!rest.variant ? 'contained' : rest.variant}
        disabled={loading ? true : rest.disabled}
        startIcon={
          loading ? (
            <CircularProgress size="1.5rem"></CircularProgress>
          ) : (
            rest.startIcon
          )
        }
        endIcon={loading ? '' : rest.endIcon}
        size={props.size ? props.size : 'small'}
      // sx={
      //   props.sx
      //     ? props.sx
      //     : {
      //       ...props.sx,
      //       height: '32px',
      //       fontSize: '14px',
      //       lineHeight: '16px'
      //     }
      // }
      >
        {props.children ? props.children : text}
      </MuiButton>
    )
  );
};

export default Button;
